import { gradients, colors } from '../../styles/theme';

interface BrandMarkProps {
  /** Show the "Investor Portal" pill next to the QMI mark. */
  showPill?: boolean;
}

/**
 * QMI gold-gradient logo mark — kept identical to the auth screens so
 * the user perceives the same product across login → app shell.
 */
const BrandMark = ({ showPill = true }: BrandMarkProps): JSX.Element => (
  <div className="flex items-center gap-2">
    <div
      className="w-8 h-8 rounded-lg flex items-center justify-center font-black text-sm"
      style={{ background: gradients.gold, color: colors.navy }}
    >
      QMI
    </div>
    {showPill && (
      <span
        className="hidden sm:inline-flex ml-1 text-xs px-2 py-0.5 rounded-full font-medium"
        style={{
          background: 'rgba(212,168,75,0.15)',
          color: colors.gold,
          border: '1px solid rgba(212,168,75,0.3)',
        }}
      >
        Investor Portal
      </span>
    )}
  </div>
);

export default BrandMark;
